import { Component, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { PowerbiReportComponent } from '@next/core-lib/powerbi-embedded';

import { Environment } from 'src/environments/environment.model';

@Component({
  selector: 'app-tga-fertilizer-evaluation',
  templateUrl: './tga-fertilizer-evaluation.component.html',
  styleUrl: './tga-fertilizer-evaluation.component.scss',
  imports: [PowerbiReportComponent],
})
export class TgaFertilizerEvaluationComponent {
  private readonly env = inject<Environment>(EnvironmentInjector);

  readonly workspaceId = this.env.TGA_FERTILIZER_DASHBOARD_WORKSPACE_ID;
  readonly reportId = this.env.TGA_FERTILIZER_DASHBOARD_REPORT_ID;
}
